import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "./config";

const PRICING_DOC = "config/pricing";

// ─── Fetch global pricing ─────────────────────────────────────────────────────
export const getPricing = async () => {
  const docRef = doc(db, "config", "pricing");
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    return docSnap.data().pricing;
  }
  return null;
};

// ─── Save global pricing ──────────────────────────────────────────────────────
export const savePricing = async (pricing) => {
  const docRef = doc(db, "config", "pricing");
  await setDoc(docRef, {
    pricing,
    updatedAt: serverTimestamp(),
  });
};
